// extracted by mini-css-extract-plugin
export default {"listItem":"TopCategoryItem_listItem__SGbkz"};